import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Container } from '../../styles/variables';
import PageStyledTitle from '../PageStyledTitle';
import useIntersection from '../useIntersection';
import StyledButton from '../StyledButton';
import Footer from './Footer';
import { email } from '../../config';

const ContactCtn = styled.div`
  .page-title-ctn{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-right: 25px;
    padding-top: 50px;
  }
  .contact-pitch{
    display: flex;
    justify-content: center;
    p{
      padding: 0 10px;
      font-size: 1rem;
      color: rgba(240, 248, 255, 0.84);
      font-weight: 350;
      width: 400px;
      text-align: center;
      margin-top: 7rem;
    }
  }
  .bottom-contact{
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }
  .overlay a{
    color: white;
    text-decoration: none;
  }
  
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

function Contact() {
  const ref = useRef(null);
  const inViewPort = useIntersection(ref, '0px');

  const contactText = (
    <p>
      Do you need a consultant to guide you in designing a solution? Want one more
      developer on your team? You might want
      to say hello. Do not hesitate. Drop a line.
    </p>
  );

  useEffect(() => {
    if (inViewPort) {
      // console.log('Contact is in viewport', inViewPort);
    }
  }, [inViewPort]);

  return (
    <Container id="contact">
      <ContactCtn>
        <div ref={ref} className="page-title-ctn">
          <PageStyledTitle mClassName="contact-title" title="Contact" />
        </div>
        <div className="contact-pitch">{contactText}</div>
        <StyledButton mClassName="bottom-contact" label="Contact me" link={`mailto:${email}`} />
      </ContactCtn>
      <Footer />
    </Container>
  );
}

export default Contact;
